export const HALF_ROTATION_ROLLER = 635

export function formatRollerDisplay(
    roller: number | null | undefined
): string | number | undefined | null {
    if (roller == null) return roller
    return roller === HALF_ROTATION_ROLLER ? 'ПР' : roller
}
